import {
  selectApps,
  selectAppTypes,
  selectAppTypesGroups,
  selectSelectedAppLocalizations,
  selectSelectedAppType
} from "../state/selectors";
import { getState } from "../state/store";

const filterAppsByDashboards = (apps, dashboards) => {
  return apps?.filter((a) => {
    return dashboards.some((dashboard) =>
      a.availableDashboards.some((d) => d.name === dashboard && d.isSelected)
    );
  });
};

const getSelectedApps = () => {
  const appType = selectSelectedAppType()(getState());
  const apps = selectApps()(getState());

  return apps?.filter((app) => appType.some((type) => type.id === app.appType));
};

const getAppName = (app) => {
  const appTypesGroups = selectAppTypesGroups()(getState()) ?? [];
  const appConfig = appTypesGroups.find((config) => config.appType === app);

  return appConfig?.name ?? app;
};

const isAppAvailable = (app) => {
  const availableAppTypes = selectAppTypes()(getState()) ?? [];

  return availableAppTypes.includes(app);
};

const isAppActive = (appType) => {
  const apps = selectAppTypesGroups()(getState()) ?? [];

  const app = apps.find((x) => x.appType === appType);

  return app && !app.isDisabled;
};

const getAvailableLanguages = () => {
  const appLocalizations = selectSelectedAppLocalizations()(getState());

  return appLocalizations?.map((l) => l.name) ?? [];
};

const filterMarketLocalizations = (marketLocalizations) => {
  const availableLanguages = getAvailableLanguages();

  return marketLocalizations?.map((config) => {
    return {
      ...config,
      languages: config?.languages?.filter((l) => availableLanguages.includes(l.name)) ?? []
    };
  });
};

const appsUtil = {
  filterAppsByDashboards,
  getSelectedApps,
  getAppName,
  isAppAvailable,
  isAppActive,
  getAvailableLanguages,
  filterMarketLocalizations
};

export default appsUtil;
